import React, { useEffect, useState } from "react";
import { MakeAxiosRequest } from "../../../utils/handler";
import Loader from "../../../Components/loader/Loader";

function AddiionalInfoOptions(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    getResponse,
    showMoreInfo = false,
    previewData,
    onSelect,
  } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [prefillDetails, setPrefillDetails] = useState([]);
  
  const fetchData = async () => {
    try {
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest("post","/getaditionalrelationdetails",{ user_proxy_key: editKey, type: "additional_information" });
        setPrefillDetails({
          description: edit.data.createUserInfo?.description,
          infoMessages: edit.data.infoMessages,
        });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "medical_information" });
        setPrefillDetails({
          description: profile.data.description,
          infoMessages: profile.data.infoMessages,
        });
      }

      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [showModal]);
  
  // console.log(previewData);
  const sections = [
    {
      title: prefillDetails.infoMessages?.find(itm=> itm.type === 'contact_information')?.title || "Contact Information",
      subtitle: prefillDetails.infoMessages?.find(itm=> itm.type === 'contact_information')?.description || "Share your contact informations.",
      type: "contact_information",
      isShow: true,
    },
    {
      title: prefillDetails.infoMessages?.find(itm=> itm.type === 'home_information')?.title || "Home Information",
      subtitle: prefillDetails.infoMessages?.find(itm=> itm.type === 'home_information')?.description || "Help us understand the home environment by sharing household size, home type, and any pets.",
      type: "home_information",
      isShow: true,
    },
    {
      title: prefillDetails.infoMessages?.find(itm=> itm.type === 'personal_information')?.title || "Personal Information",
      subtitle: prefillDetails.infoMessages?.find(itm=> itm.type === 'personal_information')?.description || "Share key details like where they grew up, occupation, interests, or anything that helps personalize their care",
      type: "personal_information",
      isShow: true,
    },
    {
      title: prefillDetails.infoMessages?.find(itm=> itm.type === 'medical_information')?.title || "Medical Information",
      subtitle: prefillDetails.infoMessages?.find(itm=> itm.type === 'medical_information')?.description || "Indicate any medical conditions or special needs to ensure the right support and accommodations.",
      type: "medical_information",
      isShow: true,
    },
    {
      title: prefillDetails.infoMessages?.find(itm=> itm.type === 'additional_information')?.title || "Additional Options",
      type: "additional_information",
      isShow: !profileEdit,
    },
  ];

  if(isLoading) return <Loader />;
  return (
    <>
      <div className="text-center">
        <h3 className="modal-title">
          {showMoreInfo ? "Great!" : "Additional Info"}
        </h3>
        {showMoreInfo && <p>Tell us more about yourself</p>}
      </div>
      <div className="form-group mt-4">
        <div className="row">
          <div className="col-12">
          {!profileEdit && previewData && <div className="mb-4 align-items-center d-flex">
            <div className="rlshp-img ms-2">
              <img src={previewData.image_path} className="prfl-sec"></img>
              <span>
                <i className="fa-solid fa-check"></i>
              </span>
            </div>

            <div>
              <p className="mb-0">{previewData.firstname+" "+previewData.lastname}</p>
              <small className="white d-block">
                {previewData.proxy_relation}
              </small>
            </div>
          </div>}
          </div>

          {prefillDetails.description && <div className="col-12 mb-3">
            <small>{prefillDetails.description}</small>
          </div>}

          {sections?.map(
            (section, index) =>
              section.isShow && (
                <>
                  <div className="col-12" onClick={() => onSelect(section.type)} key={index}>
                    <div className="d-flex justify-content-between align-items-center ">
                      <div>
                        <h6 className="mb-0">{section.title}</h6>
                        {section?.subtitle && <small>{section.subtitle}</small>}
                      </div>
                      <div><span className="material-symbols-outlined">arrow_forward_ios</span></div>
                    </div>
                    <hr />
                  </div>
                  
                </>
              )
          )}
        </div>
      </div>
      <div className="mt-4">
        <button
          type="submit"
          className="btn btn-primary rounded-pill w-100 p-2"
          onClick={closeModal}
        >
          Continue
        </button>
      </div>
    </>
  );
}

export default AddiionalInfoOptions;
